// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"84795a50","818":"eaa558e2","904":"242cc6de","994":"27584bd0"}[chunkId] + ".chunk.js";
};